export default function () {
  return {
    loading: false,
    collection: null,
    // collections: [],
  }
}
